module.exports = __webpack_public_path__ + "img/YNBLOGO-color.ad88966f.png";